import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../Layouts/PageLayout/PageLayout";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Button from "../../components/common/Button/Button";
import Modal from "../../components/common/Modal/Modal";
import Badge from "../../components/common/Badge/Badge";
import { FiCalendar, FiDownload, FiPlay, FiUsers } from "react-icons/fi";
import {
    HiUsers,
    HiScale,
    HiCurrencyEuro,
    HiOutlineCurrencyEuro,
} from "react-icons/hi";
import { LiaBalanceScaleSolid } from "react-icons/lia";
import { MdEuroSymbol, MdFilterList } from "react-icons/md";
import { GrAdd } from "react-icons/gr";
import ListadoTab from "../../components/layout/CentrosProductores/ListadoTab/ListadoTab";
import MapaTab from "../../components/layout/CentrosProductores/MapaTab/MapaTab";
import { getApiInstance } from "../../utils/api";
import Table from "../../components/common/Table/Table";
import { CiCircleCheck, CiCircleInfo, CiClock1, CiWarning } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import MapComponent from "../../components/common/MapComponent/MapComponent";
import { useZone } from "../../context/ZoneContext";
import "./CentrosProductores.scss";
import ProgressBar from "../../components/common/ProgressBar/ProgressBar";
import { mapList } from "../../utils/utils";
import { IoStopOutline } from "react-icons/io5";
import { LuWeight } from "react-icons/lu";
import { formatDate } from "../../utils/utils";

const filterFields = [
    { key: "codEspacio", label: "Código Espacio", type: "multiselect" },
    { key: "nombre", label: "Código Obra", type: "multiselect" },
    { key: "direccion", label: "Dirección", type: "multiselect" },
    { key: "intermediario", label: "Intermediario", type: "multiselect" },
    { key: "cadena", label: "Cadena", type: "multiselect" },
    { key: "tipoObra", label: "Tipo Centro", type: "multiselect" },
];

const columnasCentrosProductores = [
  { key: "codObra", label: "ID", visible: false },
  {
    key: "codEspacio",
    label: "Código Espacio",
    visible: true,
    sortable: true,
    isLink: true,
    width: "130px",
  },
  {
    key: "nombre",
    label: "Código Obra",
    visible: true,
    sortable: true,
    width: "120px",
  },
  {
    key: "direccion",
    label: "Dirección",
    visible: true,
    sortable: true,
    width: "250px",
  },
  {
    key: "fechaInicio",
    label: "Fecha inicio",
    visible: true,
    sortable: true,
    width: "120px",
    type: "date",
  },
  {
    key: "fechaFin",
    label: "Fecha fin",
    visible: true,
    sortable: true,
    width: "120px",
    type: "date",
  },
  {
    key: "intermediario",
    label: "Intermediario",
    visible: true,
    sortable: true,
    width: "130px",
  },
  {
    key: "cadena",
    label: "Cadena",
    visible: true,
    sortable: true,
    width: "120px",
  },
  {
    key: "tipoObra",
    label: "Tipo Centro",
    visible: true,
    sortable: true,
    width: "120px",
  },
  {
    key: "codEstado",
    label: "Estado",
    visible: true,
    sortable: true,
    width: "130px",
  },
];

const cumlimientosStates = [
  { label: "Sin datos", type: "info", Icon: CiClock1 },
  { label: "Pendiente", type: "info", Icon: CiClock1 },
  { label: "Validado con incidencias", type: "warning", Icon: CgDanger },
  { label: "Validada", type: "success", Icon: CiCircleCheck }]

export default function CentrosProductores() {
  const [activeTab, setActiveTab] = useState("listado");
  const [obras, setObras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedZone } = useZone();
  const [intermediarios, setIntermediarios] = useState([]);
  const [cadenas, setCadenas] = useState([]);
  const [tiposCentro, setTiposCentro] = useState([]);
  const [comunidades, setComunidades] = useState([]);
  const [paises, setPaises] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [promotores, setPromotores] = useState([]);
  const [usuariosIntermediarios, setUsuariosIntermediarios] = useState([]);
  const [productores, setProductores] = useState([]);
  const [selectedObras, setSelectedObras] = useState(new Set());

    const tabs = [
        { id: "listado", label: "Listado" },
        { id: "mapa", label: "Mapa" },
    ];

    const selectedItems = useMemo(
    () => obras.filter((obra) => selectedObras.has(obra.codObra)),
    [obras, selectedObras]
  );

    // Función para obtener el porcentaje de valorización único para cada centro
    const getValorizacionStatus = (centro) => {
        // Si viene el porcentaje real de la API, usarlo
        if (
            centro.porcentajeValorizacion !== undefined &&
            centro.porcentajeValorizacion !== null
        ) {
            return Math.max(0, Math.min(100, centro.porcentajeValorizacion));
        }

        // Generar porcentaje único basado en el ID del centro
        const id = centro.codObra || centro.id || centro.codEspacio || "0";
        let hash = 0;
        const str = id.toString();

        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }

        // Convertir hash a porcentaje entre 0-100
        const percentage = Math.abs(hash) % 101;
        return percentage;
    };

    // Función para obtener el estado de cumplimiento
    const getCumplimientoStatus = (centro) => {
        switch (centro.codEstado) {
            case "COMPLETADO":
            case "VALIDADO":
                return { status: "CORRECTO", variant: "success", Icon: CiCircleCheck };
            case "INCIDENCIA":
            case "RETRASADO":
                return { status: "INCORRECTO", variant: "danger", Icon: CgDanger};
            case "PENDIENTE":
            case "EN_PROGRESO":
                return { status: "PENDIENTE", variant: "warning", Icon: CiWarning};
            default:
                return { status: "SIN DATOS", variant: "outlined", Icon: CiCircleInfo };
        }
    };

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

  const fetchObras = async () => {
    setLoading(true);
    try {
      const api = getApiInstance();
      const response = await api.get(
        `/api/Obra/GetObrasFromZona/${selectedZone.value}/1/es`
      );

            setObras(response.data);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las obras. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

  const fetchIntermediarios = async () => {
    const api = getApiInstance();
    try {
      let intermediariosData = [];

      const response = await api.get(
        `/api/Intermediarios/GetIntermediariosByZona/${selectedZone.value}`
      );
      intermediariosData = response.data;

      setIntermediarios([
        ...mapList(intermediariosData, "nombre", "codIntermediario"),
      ]);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchCadenas = async () => {
    const api = getApiInstance();
    try {
      let cadenasData = [];

      const response = await api.get(`/api/Cadenas/GetAllCadenas`);
      cadenasData = response.data;

      setCadenas([...mapList(cadenasData, "cadena", "codCadena", "codCadena")]);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchTiposObra = async () => {
    const api = getApiInstance();
    try {
      let tiposObraData = [];

      const response = await api.get(`/api/ObrasTipo/GetAllObrasTipo`);
      tiposObraData = response.data;

      setTiposCentro([
        ...mapList(tiposObraData, "descripcion", "codTipoObra", "codTipoObra"),
      ]);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchComunidades = async () => {
    const api = getApiInstance();

    try {
      let comunidadesData = [];

      const response = await api.get(
        `/api/Comunidades/GetComunidadesByZona/${selectedZone.value}`
      );
      comunidadesData = response.data;

      setComunidades(
        mapList(
          comunidadesData,
          "comunidad",
          "codComunidad",
          "codComunidad",
          "codPais"
        )
      );

      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las comunidades. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchPaises = async () => {
    const api = getApiInstance();

    try {
      let paisesData = [];

      const response = await api.get(
        `/api/Paises/GetPaisesByZona/${selectedZone.value}`
      );
      paisesData = response.data;

      setPaises(mapList(paisesData, "pais", "codPais", "codPais"));
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar los países. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchProvincias = async () => {
    const api = getApiInstance();
    try {
      let provinciasData = [];

      const response = await api.get(
        `/api/Provincias/GetProvinciasByZona/${selectedZone.value}`
      );
      provinciasData = response.data;

      setProvincias(
        mapList(
          provinciasData,
          "provincia",
          "codProvincia",
          "codProvincia",
          "codComunidad"
        )
      );
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchPromotores = async () => {
    const api = getApiInstance();
    try {
      let promotoresData = [];

      const response = await api.get(`/api/Promotor/GetPromotores`);
      promotoresData = response.data;

      setPromotores(
        mapList(promotoresData, "promotor", "promotor", "promotor")
      );
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchUsuariosIntermediarios = async () => {
    const api = getApiInstance();
    try {
      let usuariosIntermediariosData = [];

      const response = await api.get(
        `/api/Usuario/GetAllUsuariosIntermediarios/${selectedZone.value}`
      );
      usuariosIntermediariosData = response.data;

      setUsuariosIntermediarios(
        mapList(
          usuariosIntermediariosData,
          ["nombre", "apellidos"],
          "codUsuario",
          "codIntermediario",
          "codIntermediario"
        )
      );
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductores = async () => {
    const api = getApiInstance();
    try {
      let productoresData = [];

      const response = await api.get(
        `/api/Productores/GetProductoresByZona/${selectedZone.value}`
      );
      productoresData = response.data;

      setProductores([...mapList(productoresData, "nombre", "codProductor")]);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);

    const loadAll = async () => {
      try {
        await fetchObras();

        await Promise.all([
          fetchIntermediarios(),
          fetchCadenas(),
          fetchTiposObra(),
          fetchPaises(),
          fetchComunidades(),
          fetchProvincias(),
          fetchPromotores(),
          fetchUsuariosIntermediarios(),
          fetchProductores(),
        ]);
      } catch (err) {
        if (isMounted) {
          setError(
            "No se han podido cargar los datos. Vuelve a intentarlo más tarde."
          );
        }
        console.error("Error en loadAll:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadAll();

    return () => {
      isMounted = false;
    };
  }, [selectedZone]);

    const modalMap = (centro) => {
        return (
            <div className="centro-map-details">
                <div className="centro-header">
                    <h3 className="centro-title">
                        {centro.nombre ||
                            centro.codEspacio || ""
                            }
                        , {centro.direccion || ""}
                    </h3>
                </div>

                <div className="centro-info-section">
                    <div className="info-row">
                        <FiPlay className="info-icon" />
                        <span className="info-label">Fecha inicio</span>
                        <span className="info-value">
                            {formatDate(centro.fechaInicio) || ""}
                        </span>
                    </div>
                    <div className="info-row">
                        <IoStopOutline className="info-icon" />
                        <span className="info-label">Fecha fin</span>
                        <span className="info-value">
                            {formatDate(centro.fechaFin) || ""}
                        </span>
                    </div>

                    <div className="info-row info-row--highlight">
                        <FiUsers className="info-icon" />
                        <span className="info-label">Intermediario</span>
                        <span className="info-value intermediario-link">
                            {centro.intermediario || ""}
                        </span>
                    </div>

                    <div className="info-row">
                        <LuWeight className="info-icon" />
                        <span className="info-label">Cantidades generadas</span>
                        <span className="info-value">
                            {centro.peso || ""}
                        </span>
                    </div>

                    <div className="info-row">
                        <MdEuroSymbol className="info-icon" />
                        <span className="info-label">Coste</span>
                        <span className="info-value">
                            {centro.costeTotal || ""}
                        </span>
                    </div>
                </div>

                <div className="centro-valorizacion-section">
                    <h4 className="section-title">Valorización</h4>
                    <div className="valorizacion-percentage">
                        {(centro.peso ? (centro.valorizacion / centro.peso * 100) : 0).toFixed(2)}%
                    </div>
                    <ProgressBar
                        percentage={(centro.peso ? (centro.valorizacion / centro.peso * 100) : 0).toFixed(2) || 0}
                        height={8}
                        width="100%"
                    />
                </div>

                <div className="centro-cumplimiento-section">
                    <div className="cumplimiento-header">
                        <h4 className="section-title">Cumplimiento Legal</h4>
                        <Badge variant={getCumplimientoStatus(centro).variant} Icon={getCumplimientoStatus(centro).Icon}>
                            {getCumplimientoStatus(centro).status}
                        </Badge>
                        {centro.cumplimientos.map((cumplimiento, index) => (
                            <div key={index} className="cumplimiento-item">
                                <span className="cumplimiento-name">
                                    {cumplimiento.nombre || ""}
                                </span>
                                <Badge variant={cumlimientosStates[cumplimiento.codEstado]?.type || "info"}>
                                    {cumlimientosStates[cumplimiento.codEstado]?.label || "SIN DATOS"}
                                </Badge>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="modal-actions">
                    <Button
                        variant="filled"
                        onClick={() => {
                            window.location.href = `/centros-productores/${centro.codObra}`;
                        }}
                    >
                        Ver Ficha Completa
                    </Button>
                </div>
            </div>
        );
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case "listado":
                return (
                    <Table
                        columns={columnasCentrosProductores}
                        dataTable={obras}
                        showCheckboxes={true}
                        noResultsMessage="No se han encontrado centros productores con los filtros aplicados."
                        actions={["Eliminar", "Editar"]}
                        searchTerms={[
                            "codEspacio",
                            "codObra",
                            "direccion",
                            "intermediario",
                            "cadena",
                            "tipoCentro",
                        ]}
            keyProp="codObra"
            elementName="Centro Productor"
            stateProp="codEstado"
            sortProp="codEspacio"
            states={[
              { label: "Sin datos", type: "info", Icon: CiClock1 },
              { label: "Pendiente", type: "info", Icon: CiClock1 },
              { label: "Incidencia", type: "warning", Icon: CgDanger },
              { label: "Validada", type: "success", Icon: CiCircleCheck },
              { label: "Sin documentos", type: "info", Icon: CiCircleCheck },
              { label: "Expirada", type: "danger", Icon: CiCircleCheck },
              { label: "Cerrada", type: "primary", Icon: CiCircleCheck },
            ]}
            filterFields={filterFields}
            loading={loading}
            formElements={[
              {
                title: "Información General",
                titleVisible: "true",
                elements: [
                  {
                    name: "codProductor",
                    type: "select",
                    label: "Productor",
                    placeholder: "Seleccione el productor",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: productores,
                  },
                  {
                    name: "codTipoObra",
                    type: "select",
                    label: "Tipo Centro",
                    placeholder: "Seleccione el tipo de centro",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: tiposCentro,
                  },
                  {
                    name: "codEspacio",
                    type: "text",
                    label: "Código Espacio",
                    placeholder: "Ingrese el código del espacio",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codigoObra",
                    type: "text",
                    label: "Código Obra",
                    placeholder: "Ingrese el código de obra",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codIntegracion",
                    type: "text",
                    label: "Código Integración",
                    placeholder: "Ingrese el código de integración",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "fechaInicio",
                    type: "date",
                    label: "Fecha inicio",
                    placeholder: "Seleccione la fecha de inicio",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "fechaFin",
                    type: "date",
                    label: "Fecha fin",
                    placeholder: "Seleccione la fecha fin",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "nima",
                    type: "text",
                    label: "NIMA",
                    placeholder: "Ingrese el NIMA",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codCadena",
                    type: "select",
                    label: "Cadena",
                    placeholder: "Seleccione la cadena",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: cadenas,
                  },

                  {
                    name: "codZona",
                    type: "number",
                    label: "Zona",
                    visible: false,
                    defaultValue: "1",
                  },
                ],
              },

              {
                title: "Responsables",
                titleVisible: true,
                elements: [
                  {
                    name: "codIntermediario",
                    type: "select",
                    label: "Intermediario",
                    placeholder: "Seleccione el intermediario",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: intermediarios,
                  },
                  {
                    name: "codUsuario",
                    type: "select",
                    label: "Usuario",
                    placeholder: "Seleccione el usuario",
                    options: usuariosIntermediarios,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codIntermediario",
                  },
                  {
                    name: "responsable",
                    type: "text",
                    label: "Responsable",
                    placeholder: "Ingrese el responsable",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "mailResponsable",
                    type: "text",
                    label: "Email Responsable",
                    placeholder: "Ingrese el email del responsable",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                ],
              },
              {
                title: "Ubicación",
                titleVisible: true,
                elements: [
                  {
                    name: "direccion",
                    type: "text",
                    label: "Dirección",
                    placeholder: "Ingrese la dirección",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codPais",
                    type: "select",
                    label: "País",
                    placeholder: "Introduce el país",
                    options: paises,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codComunidad",
                    type: "select",
                    label: "Comunidad",
                    placeholder: "Introduce la comunidad",
                    options: comunidades,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codPais",
                  },
                  {
                    name: "codProvincia",
                    type: "select",
                    label: "Provincia",
                    placeholder: "Introduce la provincia",
                    options: provincias,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codComunidad",
                  },
                  {
                    name: "localidad",
                    type: "text",
                    label: "Localidad",
                    placeholder: "Ingrese el nombre de la localidad",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "cp",
                    type: "text",
                    label: "Código Postal",
                    placeholder: "Ingrese el código postal",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codZona",
                    type: "number",
                    label: "Zona",
                    visible: false,
                    defaultValue: "1",
                  },
                ],
              },
              {
                title: "Datos del centro",
                titleVisible: true,
                elements: [
                  {
                    name: "codUbicacion",
                    type: "select",
                    label: "Ubicación",
                    placeholder: "Seleccione una ubicación",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: [
                      { label: "Calle", value: "1", id: 1 },
                      { label: "Centro comercial", value: "2", id: 2 },
                    ],
                  },
                  {
                    name: "superficie",
                    type: "number",
                    label: "Superficie",
                    placeholder: "Introduce una superficie",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "promotor",
                    type: "select",
                    label: "Promotor",
                    placeholder: "Seleccione un promotor",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: promotores,
                  },
                  {
                    name: "kilometros1",
                    type: "number",
                    label: "Transporte suministro materiales (KM)",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "kilometros2",
                    type: "number",
                    label: "Transporte gestión residuos (KM)",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "observaciones",
                    type: "textarea",
                    label: "Observaciones",
                    placeholder: "Ingrese una observación",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                ],
              },
            ]}
            addApiUrl="/api/Obra/SetObra"
            updateApiUrl="/api/Obra/UpdateObra"
            selectedRows={selectedObras}
            onSelectionChange={setSelectedObras}
                    />
                );
            case "mapa":
                return (
                    <MapComponent
                        data={obras}
                        center={[42.0, 2.0]}
                        zoom={5}
                        height="600px"
                        width="100%"
                        modalContent={modalMap}
                    />
                );
            default:
                return null;
        }
    };

    const handleExportarSeleccionados = () => {
    if (selectedItems.length === 0) {
      alert("Por favor, selecciona al menos un centro para exportar.");
      return;
    }

    const codigosDeObras = selectedItems.map(item => item.codObra);
        
    generateExcel({ codsProveedores: codigosDeObras });
  };

const generateExcel = async ({
  codsProveedores,
}) => {
  const api = getApiInstance(); 
  const codZona = selectedZone.value
  const codZonaLegal = 1

  try {
    const response = await api.post(
      '/api/Proveedores/CreateReportByCods',
      codsProveedores,
      {
        params: { codZona, codZonaLegal },
        responseType: 'blob',
      }
    );

    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'Informe_Proveedores.xlsx';
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (fileNameMatch && fileNameMatch.length === 2) {
        fileName = fileNameMatch[1];
      }
    }

const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (err) {
    setError("No se pudo generar el reporte. Vuelve a intentarlo más tarde.");
    console.error(err);
  }
};


    return (
        <PageLayout
            title="Centros Productores"
            subtitle="Aquí verás todos los centros productores de tu organización"
            actions={[
                <Button
                    key="export"
                    componentType="button"
                    variant="outlined"
                    startIcon={<FiDownload 
                    />
                    }
                    onClick={handleExportarSeleccionados}
                    disabled={selectedItems.length === 0}
                >
                    Exportar centros
                </Button>,
            ]}
        >
            <TabsNavigation
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />
            {renderTabContent()}
        </PageLayout>
    );
}
